import { render, staticRenderFns } from "./FavoriteGoods.vue?vue&type=template&id=011ea3de&scoped=true"
import script from "./FavoriteGoods.vue?vue&type=script&lang=js"
export * from "./FavoriteGoods.vue?vue&type=script&lang=js"
import style0 from "./FavoriteGoods.vue?vue&type=style&index=0&id=011ea3de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011ea3de",
  null
  
)

export default component.exports